// src/app/modules/Visitors/pages/visitors-table/column-formatters/RiskScoreFormatter.jsx
import React from "react";
import { Shield, AlertTriangle } from 'lucide-react';

const RISK_CONFIG = {
  low:      { pill: 'sety-pill-green',  label: 'LOW',      icon: Shield },
  medium:   { pill: 'sety-pill-purple', label: 'MEDIUM',   icon: Shield },
  high:     { pill: 'sety-pill-amber',  label: 'HIGH',     icon: AlertTriangle },
  critical: { pill: 'sety-pill-red',    label: 'CRITICAL', icon: AlertTriangle },
};

export function RiskScoreFormatter(cellContent, row) {
  const { risk_score = 0, risk_level = 'low' } = row;
  const { pill, label, icon: Icon } = RISK_CONFIG[risk_level] || RISK_CONFIG.low;

  return (
    <div>
      <span className={`sety-pill ${pill}`} style={{ marginBottom: 4 }}>
        <Icon size={12} />{label}
      </span>
      <div className="sety-tbl-sub">Score: <strong>{risk_score}</strong>/100</div>
    </div>
  );
}
